module.exports = __webpack_public_path__ + "img/spiritwear.930b9412.svg";